import { render, staticRenderFns } from "./MeasureChart.vue?vue&type=template&id=236316a1"
import script from "./MeasureChart.vue?vue&type=script&lang=js"
export * from "./MeasureChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports